import { cn } from "@/shared/lib/cn";
import marca from "@/assets/marca.svg";

export interface BrandMarkProps {
  /** Alto en píxeles. El ancho se deduce de la proporción del archivo. */
  height?: number;
  /** Texto accesible. Ponlo en `null` si un contenedor ya lo anuncia. */
  label?: string | null;
  className?: string;
}

/**
 * El imagotipo de It's The Best — el árbol con el nombre.
 *
 * Se pinta con MÁSCARA CSS y no con un `<img>`: así el color sale de
 * `--violet-pop` y sigue a la marca si la paleta cambia, sin reexportar el
 * SVG. Es la misma técnica que ya usaba la card del login.
 *
 * Por eso el elemento va vacío. Cuando lleva `label`, se anuncia como
 * imagen con ese nombre; cuando el contenedor ya lo anuncia —un enlace con
 * su propio `aria-label`—, se pasa `label={null}` para no oírlo dos veces.
 */
export function BrandMark({ height = 40, label = "It's The Best", className }: BrandMarkProps) {
  return (
    <span
      role={label ? "img" : undefined}
      aria-label={label ?? undefined}
      aria-hidden={label ? undefined : true}
      className={cn("block", className)}
      style={{
        height,
        // 3.4:1 es la proporción del archivo. Fijar el ancho evita que el
        // bloque salte de tamaño mientras la máscara carga.
        width: height * 3.4,
        backgroundColor: "var(--violet-pop)",
        WebkitMaskImage: `url(${marca})`,
        maskImage: `url(${marca})`,
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskPosition: "left center",
        maskPosition: "left center",
        WebkitMaskSize: "contain",
        maskSize: "contain",
      }}
    />
  );
}
